module.exports = __webpack_public_path__ + "media/post-listing-block-5-image@2x.fc836d0e.jpg";